export default __webpack_public_path__ + "static/media/placeholder_dummy2016-heilpraxis01-mobile-de.2a47b149.png";